<div class="row justify-content-center">
    
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">16PF</h4>
            </div>
            <div class="card-body">
                
                <h3 class="card-title">Listado de factores</h3>
                <hr>
                    <div *ngFor="let factor of factors" class="form-body">
                            
                        <div class="col-md-12 text-center">
                            <h2>Factor: {{factor.name}}</h2>
                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Baja puntuación</h3>
                                    <p>{{factor.lowDesc}}</p>
                                </div>
                            </div>

                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Alta puntuación</h3>
                                    <p>{{factor.highDesc}}</p>
                                </div>
                            </div>

                        </div>
                        <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>
                        <hr>
                    </div>
                    
                
            </div>
        </div>
    </div>
</div>